export default "__VITE_ASSET__DFW$q6sQ__"